<template>
  <AppPopup
    v-if="isOpen"
    :popupStatus="isOpen"
    :icon="isSend ? 'checkmark' : ''"
    :withoutClose="isSend"
    :title="isSend ? 'Данные успешно отправлены!' : 'Обратная связь'"
    class="feedback-popup"
    :class="[{ isSend }]"
    @popupClose="closePopup"
  >
    <template #body>
      <div v-if="!isSend" class="feedback-popup__content">
        <span class="feedback-popup__text">{{ 'Оставьте свой вопрос, мы свяжемся\nс вами в ближайшее время' }}</span>
        <form class="feedback-popup__form">
          <div v-for="(v, k) in fields" :key="k" class="feedback-popup__form-field">
            <FormElement
              v-model:value="fields[k]"
              v-maska
              tagName="input"
              :data-maska="k === 'phone' ? '+7 ### ### ## ##' : ''"
              :placeholder="formFields[k].placeholder"
              :isValid="checkFieldValidity(k, v)"
              :type="formFields[k].type"
              :errorText="errors && errors[k] ? errors[k][0] : null"
              class="feedback-popup__form-field"
              autocomplete="off"
              @update:value="checkError(k)"
            />
          </div>
          <button :disabled="!checkFieldValidity || isFeedbackLoading" type="button" class="feedback-popup__button" @click="sendForm">
            Отправить
          </button>
        </form>
      </div>
      <div v-else class="feedback-popup__content">
        <span class="feedback-popup__text">Мы свяжемся с вами в ближайшее время</span>
        <button class="feedback-popup__button" @click="closePopup">
          Ок
        </button>
      </div>
    </template>
  </AppPopup>
</template>

<script lang="ts" src="./FeedbackPopup.ts">
</script>

<style lang="scss" scoped src="./FeedbackPopup.scss"></style>
